import type { CmmdContextPaths } from "@cmmd-forge/contracts";

export interface CmmdForgeServerMaintenance {
  readonly desiredServerVersion: string | null;
  readonly observedServerVersion: string | null;
  readonly verdict: "current" | "drifted" | "unknown" | "reconciliation_required";
  readonly autoUpdate: string;
  readonly needsOperator: boolean;
}

export function requiresForgeServerReconciliation(
  maintenance: CmmdForgeServerMaintenance | undefined,
): boolean {
  return maintenance?.verdict === "drifted" || maintenance?.verdict === "reconciliation_required";
}

export interface CmmdForgeCloudProjectRuntimeRow {
  readonly runtimeId: string;
  readonly environmentId?: string | null;
  readonly status: string;
  readonly readinessPhase?: string | null;
  readonly desiredState?: string | null;
  readonly workspaceRoot?: string | null;
  readonly githubRepoFullName?: string | null;
  readonly maintenance?: CmmdForgeServerMaintenance;
}

export interface CmmdForgeCloudProjectRow {
  readonly organizationId: number;
  readonly projectId: number;
  readonly projectName?: string | null;
  readonly shortName?: string | null;
  readonly githubRepoFullName?: string | null;
  readonly iconUrl?: string | null;
  readonly icon?: string | null;
  readonly registeredAt?: string | null;
  readonly runtime?: CmmdForgeCloudProjectRuntimeRow | null;
  readonly removal?: CmmdForgeCloudProjectRemovalRow | null;
}

export interface ForgeCloudCapacity {
  readonly warmUsed: number;
  readonly warmLimit: number;
  readonly runningUsed: number;
  readonly runningLimit: number;
}

type GeneratedCloudProjectRow =
  CmmdContextPaths["/api/forge/context/cloud-projects"]["get"]["responses"][200]["content"]["application/json"]["data"]["projects"][number];

export type CmmdForgeCloudEnvironmentRow =
  CmmdContextPaths["/api/forge/context/cloud-projects"]["get"]["responses"][200]["content"]["application/json"]["data"]["environments"][number];

export type CmmdForgeCloudProjectRemovalRow = NonNullable<GeneratedCloudProjectRow["removal"]>;

/**
 * What CMMD answers a rename with (FOR-36371): the Environment as it now
 * stands, so a caller can show the settled name without waiting for a refetch.
 */
export type CmmdRenamedForgeCloudEnvironment =
  CmmdContextPaths["/api/forge/context/runtimes/{runtimeId}/rename"]["post"]["responses"][200]["content"]["application/json"]["data"];
